import PropTypes from 'prop-types'

import { Span } from 'components'

type Props = ISpan & {
  squareFeet: number | string
}

export const SquareFeet: React.FC<Props> = ({ squareFeet, ...style }) => (
  <Span {...style}>{`${squareFeet} Sq. Ft.`}</Span>
)
SquareFeet.propTypes = {
  squareFeet: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
}
